import React, { useState, useEffect } from 'react';
import {
  CircularProgress,
  InputLabel,
  MenuItem,
  Menu,
  Button,
  Box,
  Paper
} from '@material-ui/core';
import firebase from 'firebase';
import { sortBy, map, filter, repeat, includes } from 'lodash';
import LazyLoad from 'react-lazyload';
import { createTreeHierarchy, createFlatHierarchy } from 'hierarchy-js';

const Select = ({ options, value, ...props }) => {
  const [data, setData] = useState(options);
  const [items, setItems] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState(value);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (data) {
      let newItems = [];

      data.forEach(doc => {
        newItems.push({ id: doc.id, ...doc.data() });
      });

      const assignParentId = (item, currentId, index) => {
        if (!item.parentId && currentId) {
          item.parentId = currentId;
        }

        if (!item.id && currentId) {
          item.id = `${item.parentId}[${index}]`;
        }

        if (!item.order) {
          item.order = 0;
        }

        if (item.children) {
          item.children = map(item.children, (children, index) =>
            assignParentId(children, item.id, index)
          );
        }

        return item;
      };

      newItems = map(newItems, item => assignParentId(item));
      newItems = createFlatHierarchy(newItems) || [];
      setItems(newItems);
    }
  }, [data]);

  const getData = async () => {
    if (!isFetching) {
      setIsFetching(true);
      try {
        const collectionData = await firebase
          .firestore()
          .collection(props.relation.ref)
          .get();
        setData(collectionData);
      } catch (error) {
        console.error(error);
      }
    }
  };

  if (!data) {
    getData();
    return <CircularProgress />;
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = option => e => {
    setSelected(option);
    props.onChange(option);
    setAnchorEl(null);
  };

  const renderItems = (items, indent = 0) =>
    map(sortBy(items, ['order']), item => (
      <span key={item.id}>
        <MenuItem onClick={handleClose(item.id)}>{`${repeat('-', indent)} ${map(
          props.relation.fields,
          fieldName => item[fieldName]
        ).join(' ')}`}</MenuItem>
        {item.children && renderItems(item.children, indent + 1)}
      </span>
    ));

  const currentSelectedItem = selected
    ? items.find(option => option.id === selected) || {}
    : {};

  return (
    <>
      <Box mb={1}>
        <InputLabel>{props.label}</InputLabel>
      </Box>
      <Button
        variant="contained"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {selected
          ? map(
              props.relation.fields,
              fieldName => currentSelectedItem[fieldName]
            ).join(' ')
          : 'Please Select'}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose(null)}>None</MenuItem>
        {renderItems(createTreeHierarchy(items))}
      </Menu>
    </>
  );
};

export default Select;
